<ng-container *ngIf="section">
    <div [ngSwitch]="section.type">
        <div *ngSwitchCase="'MENU'">
            <app-banner-editor [section]="section"
                               (onSave)="closeDialog($event)">
            </app-banner-editor>
        </div>
        <div *ngSwitchCase="'COVER'">
            <app-banner-editor [section]="section"
                               (onSave)="closeDialog($event)">
            </app-banner-editor>
        </div>
        <div *ngSwitchCase="'BANNER'">
            <app-banner-editor [section]="section"
                               (onSave)="closeDialog($event)">
            </app-banner-editor>
        </div>
        <div *ngSwitchCase="'CAROUSEL'">
            <app-carousel-editor [section]="section"
                                 (onSave)="closeDialog($event)"
                                 [listType]="'CAROUSEL'">
            </app-carousel-editor>
        </div>

        <div *ngSwitchCase="'BUCKET'">
            <app-carousel-editor [section]="section"
                                 (onSave)="closeDialog($event)"
                                 [listType]="'BUCKET'">
            </app-carousel-editor>
        </div>
    </div>
</ng-container>
